jQuery( document ).ready( function( $ ) {

    /**
     * Contact Page content toggle
     */
    /*$('button.request-service').click(function() {
        $('.contact-container.main').removeClass('d-block').addClass('d-none');
        $('.contact-container.request-service').removeClass('d-none').addClass('d-block');
    });

    $('button.request-a-quote').click(function() {
        $('.contact-container.main').removeClass('d-block').addClass('d-none');
        $('.contact-container.request-a-quote').removeClass('d-none').addClass('d-block');
    });

    $('button.back-to-options').click(function() {
        $('.contact-container.main').removeClass('d-none').addClass('d-block');
        $('.contact-container.request-a-quote, .contact-container.request-service').removeClass('d-block').addClass('d-none');
    });*/        


    /**
     * Add class to job posting when button is clicked
     */
    $('.job-form-reveal').click(function() {
        $('.job-form-container').toggleClass('open');
    });

    
    /**
     * Arrow graphics on About page
     */
    if($('.about-triangle-container').length){
      $(window).scroll(function() {
          var wScroll = $(this).scrollTop();
          $('.triangle--purple').css({
              transform: 'translateX(' + wScroll / 53 + '%)'
          });
          /*$('.triangle--red').css({
              transform: 'translateX(' + wScroll / 70 + '%)',
          });*/
          $('.triangle--teal').css({
              transform: 'translateX(' + wScroll / 12 + '%)'
          });                    
      });
    }


    /**
     * Add class to navbar-toggler when clicked
     */
    $('.navbar-toggler').click(function() {
        $(this).toggleClass('open');
        $('body').toggleClass('menu-active');  
        $(this).parents().next('.mega-menu').toggleClass('open');
        //$(this).parents('.site-header.fixed-top').toggleClass('overflow');   
        if ( $(this).parents('.site-header.fixed-top').hasClass('overflow') ) {
          setTimeout(function() {
            $('.site-header.fixed-top').toggleClass('overflow');
          }, 250);
        } else {
          $(this).parents('.site-header.fixed-top').toggleClass('overflow');
        }
    });


    /**
     * Set cookie for site notification dismissal
     */
    if ($.cookie('site_note_close') != 'true') {
      $('.site-notification').removeClass('d-none');

      $('.site-note-close').click(function() {
        $.cookie('site_note_close', 'true', { expires: 10, path: '/' }); 
      });
    } else if ($.cookie('site_note_close') === 'true') {        
    };     
  

    /**
     * Home - product buckets
     */ 
    $( '.product-bucket' ).each(function( index ) {
      var fullContainerHeight = $(this).find('.product-bucket__container--inner').outerHeight();
      var titleHeight = $(this).find('h2').outerHeight(true);
      var bottomButtonHeight = $(this).find('.product-bucket__link').outerHeight();
      
      //console.log("full content: "+fullContainerHeight);
      //console.log("title: "+titleHeight);
      //console.log("bottom button: "+bottomButtonHeight);
      
      // original calc to adjust content but show title at very bottom of container
      //var initialState = (Math.ceil(fullContainerHeight) - Math.ceil(titleHeight)) - Math.ceil(bottomButtonHeight);

      // new calc to adjust content to bottom of container
      var initialState = Math.ceil(fullContainerHeight) - Math.ceil(bottomButtonHeight);
      
      $(this).find('.product-bucket__content').css('top', initialState);
      
      $(this).find('.product-bucket__container').on('mouseover', function() {
        $(this).find('.product-bucket__content').css('top', 15);
      });
      
      $(this).find('.product-bucket__container').on('mouseout', function() {
       $(this).find('.product-bucket__content').css('top', initialState);
      });
      
      //console.log(initialState);
      
    });


    /**
     * Home - questions block functionality
     */
    /*function hovered() {
      $this = $(this); // here $this keeps the reference of $(this)
      $this.addClass('hovered');
      //setTimeout( function() { 
        $this.children('.question-block__up').removeClass('fade-in').addClass('fade-out');
        $this.children('.question-block__hover').addClass('fade-in').removeClass('fade-out');
      //}, 250);      
    }
    function hoveredOut() {
      $this = $(this); // here $this keeps the reference of $(this)
      $this.removeClass('hovered');      
      $this.children('.question-block__up').addClass('fade-in').removeClass('fade-out');
      $this.children('.question-block__hover').addClass('fade-out').removeClass('fade-in');                          
    }    

    $('.question-block__container').hoverIntent({
      over: hovered,
      out: hoveredOut,
      timeout: 2,  
    });*/
     

    /**
     * MatchHeight settings
     */
    $('.article-bottom h2').matchHeight();
    $('.article-bottom .custom-excerpt').matchHeight();
    $('.product-grid-content header').matchHeight();


    /**
     * Default Slick Slider Example
     */
    $('.slick-slideshow').slick({
      dots: true,
      arrows: false,
    });

    $('.homepage-slideshow').slick({
      dots: true,
      arrows: false,      
      autoplay: true,
      autoplaySpeed: 8000,
      pauseOnHover: false
    });    

    $('.logo-slideshow').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: false,      
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]     
    });    


    /**
     * Create a "clickable" class which makes entire container clickable
     */
    $('.clickable').click(function() {
        window.location = $(this).find('a').attr('href'); 
        return false;
    });
    $('.clickable-external').click(function() {
        var click_external_url = $(this).find('a').attr('href');
        window.open(click_external_url);
        return false;
    });    


    /**
     * Smooth Scroll Hashed Links
     * This will scroll to link on same page
     * Or will smoothly scroll to a hashed section on another page after click
     */

    // first check if the window location contains a hash, then set it to top straight away
    if (window.location.hash) scroll(0,0);
    // void some browsers issue
    setTimeout( function() { scroll(0,0); }, 1);

    $(function() {
      // your current click function
      // select all links with hashes, remove if don't link to anything (:not)
      // this is for same page hashed links
      $('a[href*=\\#]:not([href=\\#])').on('click', function() {
          if (!$(this).parents('ul').hasClass('nav-pills')) {
              var target = $(this.hash);
              // if target.length is 0, set target equal to the name attribuite with hash as value
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // smooth scroll to the target id
              if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 100
                }, 1000);
                return false; 
              }
          }
      });

      // check if the window location (URL) has a hash in it
      // smoothly scroll to that location
      if(window.location.hash) {
          var target = $(window.location.hash);
          // if target.length is 0, set target equal to the name attribuite with hash as value
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          // smooth scroll to the target id
          $('html, body').delay(1000).animate({
            scrollTop: $(target).offset().top - 100
          }, 1000);
          return false;
      }

    });


} );
